<template>
  <div class="app-selector q-pa-md">
    <h6 class="text-center text-bold q-mt-xs">Доступные Web-приложения</h6>
    <div
      v-for="app in apps"
      :key="app.id_app"
      class="app-card row items-center no-wrap"
      @click="goToApp(app)"
    >
      <div class="icon-wrap row items-center justify-center">
        <q-icon
          :name="app.ppl_access_default ? 'apps' : 'lock'"
          size="24px"
          color="grey-6"
        />
      </div>

      <div class="col q-ml-md">
        <div class="title">
          {{ app.title }}
        </div>
        <div class="subtitle text-grey-6">
          {{ app.ppl_access_default ? 'Публичное' : 'Требуется разрешение' }}
        </div>
      </div>

      <q-icon
        name="chevron_right"
        size="24px"
        color="grey-5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { useRouter } from 'vue-router';

export interface AppAccessItem {
  id_app: number
  link: string
  name_app: string
  ppl_access_default: number
  title: string
}

const props = defineProps({
  apps: {
    type: Array as PropType<AppAccessItem[]>,
    required: true,
  },
});

const router = useRouter();

const buildRedirectLink = (link: string): string => {
  const trimmed = link.trim();

  if (trimmed.endsWith('/#/')) {
    return `${trimmed}redirect-login`;
  }

  if (
    !trimmed.includes('#')
    && (trimmed.endsWith('/') || !trimmed.endsWith('/'))
  ) {
    return trimmed.endsWith('/')
      ? `${trimmed}redirect-login`
      : `${trimmed}/redirect-login`;
  }

  return trimmed;
};

const goToApp = (app: AppAccessItem) => {
  if (!app.link) return;
  if (app.link.startsWith('/')) {
    router.push(app.link);
  } else {
    const finalLink = buildRedirectLink(app.link);
    window.open(finalLink, '_blank', 'noopener,noreferrer');
  }
};
</script>

<style scoped>
.app-selector {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.app-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.app-card:active {
  background-color: #f2f4f7;
}

.icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f1f3f5;
  flex-shrink: 0;
}

.title {
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
}

.subtitle {
  font-size: 13px;
  line-height: 18px;
}
</style>
